import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class ConnectionCriteriaExt extends BasicCriteria {
kind: string;
}

